import { ReactNode } from "react";
import { twClassMerge } from "../twClassMerge/twClassMerge";

interface Props {
  tag:
    | "h1"
    | "h2"
    | "h3"
    | "h4"
    | "h5"
    | "h6"
    | "p"
    | "strong"
    | "span"
    | "small";
  className?: string;
  children?: ReactNode;
  id?: string;
  onClick?: () => void;
}

const typographyClasses = {
  h1: "text-[2em] font-bold my-[0.67em]",
  h2: "text-[1.5em] font-bold my-[0.67em]",
  h3: "text-[1.17em] font-bold my-[0.67em]",
  h4: "text-[1em] font-bold my-[0.67em]",
  h5: "text-[0.83] font-bold my-[0.67em]",
  h6: "text-[0.67] font-bold my-[0.67em]",
  p: "block my-[1em]",
  span: "text-inherit",
  strong: "font-bold",
  small: "text-xs",
};

export const Typography: React.FC<Props> = ({
  tag,
  id,
  className = "",
  children,
  onClick,
  ...rest
}) => {
  const Tag = tag;

  return (
    <Tag
      id={id}
      onClick={onClick}
      className={twClassMerge(typographyClasses[tag], className)}
      {...rest}
    >
      {children}
    </Tag>
  );
};
